import React, {Component} from "react"

class MenuView extends Component {
    render() {
        return (
            <div className="content container">
                <div id="carouselExampleControls" className="carousel slide full-width-carrousel" data-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div style={{background: "url('/images/menu/header.png') no-repeat center"}}><span style={{display: "inline-block", height: "10rem"}}></span></div>
                        </div>
                    </div>
                    {/* <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a> */}
                </div>
                <h2>Menukaart</h2>
                <p>Onze ijskarren rijden doorheen het Waasland en ver daarbuiten met de volgende 13 smaken:</p>
                <ul>
                    <li>Vanille</li>
                    <li>Chocolade</li>
                    <li>Aardbei</li>
                    <li>Banaan</li>
                    <li>Mokka</li>
                    <li>Framboos</li>
                    <li>Limoncello</li>
                    <li>Tropical</li>
                    <li>Smurf</li>
                    <li>Yoghurt-Bosvruchten</li>
                    <li>Cookies</li>
                    <li>Foubert Rocher</li>
                    <li>Stracciatella</li>
                </ul>
            </div>
        )
    }
}

export default MenuView